import React, {Fragment} from "react";
import ActionPopover from "../popovers/ActionPopover";
import CircleButton from "./CircleButton";

export default function CircleButtonsGroup({
                                               buttons = [{
                                                   isSelected: false,
                                                   title: "",
                                                   confirmMessage: null,
                                                   iconClassName: "",
                                                   onClick: () => {
                                                   },
                                                   customBtn: null,
                                                   isLoading: false,
                                                   isHidden: false
                                               }],
                                               style
                                           }) {
    return (
        <div className="circle-btn-group" style={style}>
            {buttons.map(btn => <Fragment key={btn.title}>
                    {
                        btn.customBtn
                            ? btn.customBtn
                            : btn.confirmMessage
                            ? <ActionPopover
                                button={
                                    <CircleButton iconClassName={btn.iconClassName} title={btn.title}
                                                  isSelected={btn.isSelected} isLoading={btn.isLoading} isHidden={btn.isHidden} />
                                }
                                tooltip={btn.confirmMessage}
                                popoverLocation='top'
                                label={btn.confirmMessage}
                                handleSubmit={btn.onClick}/>
                            : <CircleButton iconClassName={btn.iconClassName} title={btn.title} isSelected={btn.isSelected}
                                            onClick={btn.onClick} confirmMessage={btn.confirmMessage} isLoading={btn.isLoading}
                                            isHidden={btn.isHidden}/>
                    }
                </Fragment>
            )}
        </div>
    )
}


